import styled from 'styled-components';
import { getPackageGradient } from './ActivePackageCard.helpers';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const DetailsCard = styled.div<{ $packageName: string }>`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 25px 20px;
  border-radius: 21px;
  margin: 10px 0;
  background: ${({ $packageName }) => getPackageGradient($packageName)};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 25px;
  gap: 10px;
`;

export const Title = styled(Typography.Body)`
  font-size: 16px;
  font-weight: 700;
`;

export const DiscountIcon = styled.span`
  display: inline-flex;
  flex: 0 0 25px;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.system.blue};
  color: ${({ theme }) => theme.palette.system.white};
`;

export const Features = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Feature = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 14px;
  padding: 5px 0;
`;

export const CheckIconBox = styled.span`
  display: inline-flex;
  flex: 0 0 11px;
  align-items: center;
  justify-content: center;
`;

export const Actions = styled.div`
  padding-top: 25px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 0 calc(17px + env(safe-area-inset-bottom));
  }
`;

export const RenewButton = styled(Button).attrs({
  appearance: 'secondary',
  isFullWidth: true,
  borderRadius: 14,
})`
  height: 44px;
  font-size: 15px;
  padding: 15px;
`;
